import {
  Backdrop,
  Container,
  Fade,
  Modal,
  Paper,
} from '@material-ui/core';
import React from 'react';
import { arrayOf, object, string, func, shape } from 'prop-types';

import modalConstants, { modalTypes } from 'Services/constants/modals';
import ModalCloseButton from './ModalCloseButton';
import styles from './styles.scss';

const ModalBase = ({ modals, modalClose }) => (
    <React.Fragment>
      {
        modals.map((modal) => {
          if (!modal || !modal.id) return null;
          const ModalChildren = modalConstants[modal.id];
          if (!ModalChildren) return null;
          const handleClose = () => modalClose(modal.id);
          const type = modal.type || modalTypes.DEFAULT;
          if (type === modalTypes.CUSTOM) {
            return (
              <ModalChildren {...(modal.modalProps || {})} key={modal.id} onClose={handleClose} />
            );
          }
          return (
            <Modal
              key={modal.id}
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
              className={styles.modal}
              closeAfterTransition
              onClose={handleClose}
              open
            >
              <Fade in>
                <Paper classes={{ root: styles.paper }}>
                  <Container classes={{ root: styles.container }} maxWidth="sm">
                    <ModalCloseButton onClose={handleClose} />
                    <ModalChildren {...(modal.modalProps || {})} onClose={handleClose} />
                  </Container>
                </Paper>
              </Fade>
            </Modal>
          );
        })
      }
    </React.Fragment>
);

const ModalInstanceProps = {
  id: string.isRequired,
  modalProps: object,
};

const MapStateProps = {
  modals: arrayOf(shape(ModalInstanceProps)).isRequired,
};

const MapDispatchProps = {
  modalClose: func.isRequired,
};

ModalBase.propTypes = {
  ...MapStateProps,
  ...MapDispatchProps,
};

export default ModalBase;
